import { render, staticRenderFns } from "./MajorCreate.vue?vue&type=template&id=58bbf2bc&scoped=true&"
import script from "./MajorCreate.vue?vue&type=script&lang=js&"
export * from "./MajorCreate.vue?vue&type=script&lang=js&"
import style0 from "./MajorCreate.vue?vue&type=style&index=0&id=58bbf2bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bbf2bc",
  null
  
)

export default component.exports